<template>
  <v-breadcrumbs :items="navigation" class="pl-6">
    <template v-slot:divider>
      <v-icon>mdi-chevron-right</v-icon>
    </template>
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
        {{ item.text }}
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>
<script>
import { mapState } from 'vuex'

export default {
  props: {
  },
  data: () => ({ }),
  computed: {
    ...mapState('core', ['navigation']),
  },
}
</script>
<style>
</style>
  